import React, { useEffect, useContext } from 'react';

import { initEsriGlobalNav } from '../../utils/esri-global-nav';

import {
    SiteNav,
    TopBanner,
    IntroSection,
    FiftyFifty,
    FooterSection,
    BrowseApp,
} from '../../components';

import BannerImage from '../../statics/img/banner.jpg';

import { EsriOAuthContext } from '../../contexts/EsriOAuthProvider';

const RootPage = () => {
    const { signIn, signOut, userData } = useContext(EsriOAuthContext);

    useEffect(() => {
        initEsriGlobalNav({
            userData,
            signIn,
            signOut,
        });
    }, []);

    return (
        <>
            {/* per Sean, leave it as blank for now */}
            <SiteNav title={''} />
            <TopBanner
                title="Esri Open Access National Datasets"
                subTitle="Sharing critical Nation Geospatial Data Assets from the official sources"
                backgroundImageURL={BannerImage}
            />
            <IntroSection />
            <FiftyFifty />
            <BrowseApp />
            <FooterSection />
        </>
    );
};

export default RootPage;
